import { Navigate } from "react-router"
import { useAuthStore } from "@/feature/auth/store/authStore"
import { useGetUserQuery } from "@/feature/auth/api"

export const AuthRootPage = () => {
  const { session } = useAuthStore()
  const { data: userData, isLoading, isFetching } = useGetUserQuery()
  if (isLoading || isFetching) {
    return <div>Loading...</div>
  }
  if (session?.access_token) {
    if (userData?.status === `pending`) {
      return <Navigate to="/resend" />
    }
    if (userData?.status === `verified`) {
      return <Navigate to="/wizard" />
    }
    return <Navigate to="/dashboard" />
  }
  return <Navigate to="/auth/login" />
}
